import type { CSSProperties } from "react";

type Props = {
  thumbUrl: string;
  geometry: CSSProperties;
  className: string;
};

const ProviderTileThumb: FC<Props> = ({ thumbUrl, geometry, className }) => (
  <img
    src={thumbUrl}
    alt=""
    loading="lazy"
    className={`absolute rounded-lg object-cover ${className}`}
    style={geometry}
  />
);

export default ProviderTileThumb;
